export default __webpack_public_path__ + "static/media/flashpass_poster.4eb8bf79.svg";